import React from "react";

const DraggableElement = ({ element }) => {
    const style = {
        padding: element.style.padding || "10px",
        margin: element.style.margin || "0px",
        backgroundColor: element.style.backgroundColor || "transparent",
        color: element.style.color || "inherit",
        fontSize: element.style.fontSize ? `${element.style.fontSize}px` : "inherit",
        textAlign: element.style.textAlign || "left",
        fontWeight: element.style.fontWeight || "normal",
        borderRadius: element.style.borderRadius ? `${element.style.borderRadius}px` : "0px",
        position: "relative",
        minHeight: "40px",
        ...element.style // Apply other custom styles
    };

    return (
        <div style={style} className="canvas-element">
            {element.type === "text" && (
                <div dangerouslySetInnerHTML={{ __html: element.content || "" }} />
            )}
            {element.type === "image" && (
                <img
                    src={element.content || "https://via.placeholder.com/150"}
                    alt="content"
                    style={{ maxWidth: "100%", display: "block" }}
                />
            )}
            {element.type === "box" && (
                <div
                    style={{
                        minHeight: "50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {element.content}
                </div>
            )}
        </div>
    );
};

export default function VisualPageRenderer({ content }) {
    let state = {};
    try {
        state = typeof content === "string" ? JSON.parse(content) : content;
    } catch (e) {
        console.error("Failed to parse Visual Page content", e);
        return <div>Error loading content</div>;
    }

    const { elements = [], pageStyle = {} } = state;

    return (
        <div
            style={{
                width: "100%",
                maxWidth: "1200px",
                margin: "0 auto",
                background: pageStyle.backgroundColor || "transparent",
                minHeight: "100%",
                padding: pageStyle.padding || "40px",
                color: "#333",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                boxSizing: "border-box"
            }}
        >
            {elements.map((el) => (
                <DraggableElement key={el.id} element={el} />
            ))}
        </div>
    );
}
